export const TWO_FACTOR_METHOD_SMS = "sms";
export const TWO_FACTOR_METHOD_EMAIL = "email";
export const TWO_FACTOR_METHOD_AUTHENTICATOR = "authenticator";
export const TWO_FACTOR_DEFAULT_METHOD = TWO_FACTOR_METHOD_EMAIL;

const storageKey = (userId) => `godiway_2fa_${userId}`;

export function getDefaultTwoFactorSettings() {
  return {
    enabled: false,
    method: TWO_FACTOR_DEFAULT_METHOD,
    email: "",
    phone: "",
    otpauthUrl: "",
  };
}

export function getTwoFactorSettings(userId) {
  if (!userId) {
    return getDefaultTwoFactorSettings();
  }

  try {
    const stored = localStorage.getItem(storageKey(userId));
    if (!stored) {
      return getDefaultTwoFactorSettings();
    }

    const parsed = JSON.parse(stored);
    return {
      enabled: Boolean(parsed.enabled),
      method: parsed.method || TWO_FACTOR_DEFAULT_METHOD,
      email: parsed.email || "",
      phone: parsed.phone || "",
      otpauthUrl: parsed.otpauthUrl || "",
    };
  } catch (error) {
    return getDefaultTwoFactorSettings();
  }
}

export function saveTwoFactorSettings(userId, settings) {
  if (!userId) {
    return;
  }

  try {
    localStorage.setItem(
      storageKey(userId),
      JSON.stringify({
        enabled: Boolean(settings.enabled),
        method: settings.method || TWO_FACTOR_DEFAULT_METHOD,
        email: settings.email || "",
        phone: settings.phone || "",
        otpauthUrl: settings.otpauthUrl || "",
      })
    );
  } catch (error) {
    // ignore storage errors
  }
}
